// @ts-nocheck
import * as GraphQLSchema from '../graphql-types';

import * as Operations from './get-default-service-category-query.graphql';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type BudgetSupportTypesQueryVariables = GraphQLSchema.Exact<{
  consumerUserId?: GraphQLSchema.InputMaybe<GraphQLSchema.Scalars['ID']['input']>;
  postedJobId?: GraphQLSchema.InputMaybe<GraphQLSchema.Scalars['ID']['input']>;
}>;


export type BudgetSupportTypesQuery = { __typename?: 'Query', budgetSupportTypes?: { __typename?: 'CarerBudgetSupport', defaultBudgetSupportTypes?: Array<{ __typename?: 'BudgetSupportType', id: string, name: string, displayName?: string | null, isAdminOnlyType?: boolean | null }> | null } | null };


  @Injectable({
    providedIn: 'root'
  })
  export class BudgetSupportTypesQueryService extends Apollo.Query<BudgetSupportTypesQuery, BudgetSupportTypesQueryVariables> {
    document = Operations.BudgetSupportTypesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }